import Grid from "@mui/material/Grid";
import FormController from "../formController/FormController";
import { useRecoilValue } from "recoil";
import { isGlobalEditModeState, sapEnumState } from "../../state/customerbaseState";
import { CBCreationOfProps } from "../../types";
import { filterSalesOrganizationByTenants } from "../../utils";
import { useContext } from "react";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";

interface CBSalesAreaProps extends CBCreationOfProps {
    index: number
}
const CBSalesArea = ({
    index,
    creationOf
} : CBSalesAreaProps) => {

    const { globalData } = useContext(GlobalContext);
    
    const isCreationMode = !!creationOf;

    const editing = useRecoilValue(isGlobalEditModeState);
    const sapEnum = useRecoilValue(sapEnumState);

    return (
        <Grid container columnSpacing={3} rowSpacing={1}>
            <Grid item md={6} xs={12}>
                <FormController 
                    formName={`salesAreas.${index}.salesOrganization`}
                    idField={`sales-area-sales-organization-${index}`}
                    label="salesOrganization"
                    options={sapEnum.salesOrganizations || []}
                    showSelect={isCreationMode || editing}
                    isMandatory
                />
            </Grid>
            <Grid item md={6} xs={12}>
                <FormController 
                    formName={`salesAreas.${index}.distributionChannel`}
                    idField={`sales-area-distribution-channel-${index}`}
                    label="distributionChannel"
                    options={sapEnum.distributionChannels || []}
                    showSelect={isCreationMode || editing}
                    isMandatory
                />
            </Grid>
            <Grid item md={6} xs={12}>
                <FormController 
                    formName={`salesAreas.${index}.division`}
                    idField={`sales-area-division-${index}`}
                    label="division"
                    translationLabel="sapEnum.divisions"
                    options={sapEnum.divisions || []}
                    showSelect={isCreationMode || editing}
                    isMandatory
                />
            </Grid>
            <Grid item md={6} xs={12}>
                <FormController 
                    formName={`salesAreas.${index}.currency`}
                    idField={`sales-area-currency-${index}`}
                    label="currency"
                    options={sapEnum.currencies || []}
                    showSelect={isCreationMode || editing}
                    isMandatory
                />
            </Grid>
        </Grid>
    )
}

export default CBSalesArea;